<template>
	<div></div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      
    }
  },
}	
</script>


// WEBPACK FOOTER //
// src/contract/contract.vue